import { MapDataSourceId } from "../models/MapDataSource";
import { IExportQueryBuilder } from './abstractions/IExportQueryBuilder';


export class MapExportQueryBuilderProvider {
  private _builders = new Map<MapDataSourceId, IExportQueryBuilder>();

  register(dataSourceId: MapDataSourceId, builder: IExportQueryBuilder) {
    this._builders.set(dataSourceId, builder);
  }

  resolve(dataSourceId: MapDataSourceId) {
    if (!this._builders.has(dataSourceId)) {
      throw new Error(`${dataSourceId} export query builder is not registered`);
    }
    return this._builders.get(dataSourceId)!;
  }
}